import React, { ReactNode, useContext, useEffect, useRef, useState } from "react";
import { RecadastramentoContext } from "@contexts";
import { FaEdit, FaPlus, FaTimes } from "react-icons/fa";
import { DependenteEntidade, WebRecadParticipanteDadosEntidade } from "@entidades";
import { HouveAlteracao, StringIsNullOrEmpty } from "@helpers";
import { LoadingComponent } from "@components";
import { Alert, Box, StaticField } from "@intech/web-ui";
import { Icon, IconContainer } from "./styles";
import moment from "moment";

export const Alteracoes: React.FC = () => {
  const isMountedRef = useRef(true);
  const context = useContext(RecadastramentoContext);

  const icons =
  {
    "INC": <FaPlus />,
    "ALT": <FaEdit />,
    "EXC": <FaTimes />
  };

  const title =
  {
    "INC": "Inclusão",
    "ALT": "Alteração",
    "EXC": "Exclusão"
  };

  const [Erro, setErro] = useState<ReactNode>("");
  const [DadosFinais, setDadosFinais] = useState<WebRecadParticipanteDadosEntidade>();
  const [DadosOriginais, setDadosOriginais] = useState<WebRecadParticipanteDadosEntidade>();
  const [ListaDependentes, setListaDependentes] = useState<Array<DependenteEntidade>>(new Array<DependenteEntidade>());
  const [TeveAlteracoes, setTeveAlteracoes] = useState<boolean>(false);
  const [Loading, setLoading] = useState<boolean>(false);

  useEffect(() => () => { isMountedRef.current = false }, []);

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        if (!isMountedRef.current)
          return;

        const dadosFinais = await context.buscarDadosParticipante();
        const dadosOriginais = await context.buscarDadosOriginais();
        const listaDependentes = await context.buscarListaDependentes();

        setDadosFinais(dadosFinais);

        setDadosOriginais(dadosOriginais);

        const itens = Object.values(dadosFinais);

        const AlteracoesCampos = itens.some(x => x !== null);

        const ListaDependentes = listaDependentes.filter(dep => !StringIsNullOrEmpty(dep.IND_OPERACAO));

        setTeveAlteracoes(AlteracoesCampos || ListaDependentes.length > 0);

        setListaDependentes(ListaDependentes);
      }
      catch (err) {
        setErro(err["response"] ? err["response"]["data"] : err);
      }
      finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <>
      {Loading && <LoadingComponent />}

      {!Loading && Erro !== "" && <Alert type={"danger"}>{Erro}</Alert>}

      {!Loading && Erro === "" && <>
        {TeveAlteracoes && (
          <>
            {HouveAlteracao(DadosFinais.NOME_ENTID, DadosOriginais.NOME_ENTID) && <StaticField value={DadosFinais.NOME_ENTID} title={"Nome"} labelSize={4} />}

            {HouveAlteracao(DadosFinais.DT_EMIS_IDENT, DadosOriginais.DT_EMIS_IDENT) && <StaticField value={DadosFinais.DT_EMIS_IDENT} title={"Data de Emissão"} labelSize={4} />}

            {HouveAlteracao(DadosFinais.ORG_EMIS_IDENT, DadosOriginais.ORG_EMIS_IDENT) && <StaticField value={DadosFinais.ORG_EMIS_IDENT} title={"Órgão Emissor"} labelSize={4} />}

            {HouveAlteracao(DadosFinais.NATURALIDADE, DadosOriginais.NATURALIDADE) && <StaticField value={DadosFinais.NATURALIDADE} title={"Naturalidade"} labelSize={4} />}

            {HouveAlteracao(DadosFinais.UF_NATURALIDADE, DadosOriginais.UF_NATURALIDADE) && <StaticField value={DadosFinais.UF_NATURALIDADE} title={"Naturalidade - Estado"} labelSize={4} />}

            {HouveAlteracao(DadosFinais.CD_ESTADO_CIVIL, DadosOriginais.CD_ESTADO_CIVIL) && <StaticField value={DadosFinais.DS_ESTADO_CIVIL} title={"Estado Civil"} labelSize={4} />}

            {HouveAlteracao(DadosFinais.NOME_CONJUGE, DadosOriginais.NOME_CONJUGE) && <StaticField value={DadosFinais.NOME_CONJUGE} title={"Nome do Conjuge"} labelSize={4} />}

            {HouveAlteracao(DadosFinais.CPF_CONJUGE, DadosOriginais.CPF_CONJUGE) && <StaticField value={DadosFinais.CPF_CONJUGE} title={"CPF do Conjuge"} labelSize={4} />}

            {HouveAlteracao(DadosFinais.CEP_ENTID, DadosOriginais.CEP_ENTID) && <StaticField value={DadosFinais.CEP_ENTID} title={"CEP"} labelSize={4} />}

            {HouveAlteracao(DadosFinais.END_ENTID, DadosOriginais.END_ENTID) && <StaticField value={DadosFinais.END_ENTID} title={"Endereço"} labelSize={4} />}

            {HouveAlteracao(DadosFinais.NR_END_ENTID, DadosOriginais.NR_END_ENTID) && <StaticField value={DadosFinais.NR_END_ENTID} title={"Número"} labelSize={4} />}

            {HouveAlteracao(DadosFinais.COMP_END_ENTID, DadosOriginais.COMP_END_ENTID) && <StaticField value={DadosFinais.COMP_END_ENTID} title={"Complemento"} labelSize={4} />}

            {HouveAlteracao(DadosFinais.BAIRRO_ENTID, DadosOriginais.BAIRRO_ENTID) && <StaticField value={DadosFinais.BAIRRO_ENTID} title={"Bairro"} labelSize={4} />}

            {HouveAlteracao(DadosFinais.CID_ENTID, DadosOriginais.CID_ENTID) && <StaticField value={DadosFinais.CID_ENTID} title={"Cidade"} labelSize={4} />}

            {HouveAlteracao(DadosFinais.UF_ENTID, DadosOriginais.UF_ENTID) && <StaticField value={DadosFinais.DS_UF_ENTID} title={"Estado"} labelSize={4} />}

            {HouveAlteracao(DadosFinais.EMAIL_AUX, DadosOriginais.EMAIL_AUX) && <StaticField value={DadosFinais.EMAIL_AUX} title={"E-mail Pessoal"} labelSize={4} />}

            {HouveAlteracao(DadosFinais.FONE_ENTID, DadosOriginais.FONE_ENTID) && <StaticField value={DadosFinais.FONE_ENTID} title={"Telefone Residencial"} labelSize={4} />}

            {HouveAlteracao(DadosFinais.FONE_CELULAR, DadosOriginais.FONE_CELULAR) && <StaticField value={DadosFinais.FONE_CELULAR} title={"Telefone Celular"} labelSize={4} />}

            {/* {HouveAlteracao(DadosFinais.NUM_BANCO, DadosOriginais.NUM_BANCO) && <StaticField value={DadosFinais.NUM_BANCO} title={"Número do Banco"} labelSize={4} />}

            {HouveAlteracao(DadosFinais.NUM_AGENCIA, DadosOriginais.NUM_AGENCIA) && <StaticField value={DadosFinais.NUM_AGENCIA} title={"Agência (sem o Dígito)"} labelSize={4} />}

            {HouveAlteracao(DadosFinais.NUM_CONTA, DadosOriginais.NUM_CONTA) && <StaticField value={DadosFinais.NUM_CONTA} title={"Conta Corrente (com o DV)"} labelSize={4} />} */}

            {HouveAlteracao(DadosFinais.POLIT_EXP, DadosOriginais.POLIT_EXP) && <StaticField value={DadosFinais.POLIT_EXP} title={"Pessoa Politicamente Exposta"} labelSize={4} />}

            {ListaDependentes.length > 0 &&
              <Box title={"Beneficiários para fins de Pensão/Benefício por Morte"}>
                <table className={"table table-responsive table-bordered"}>
                  <thead>
                    <tr>
                      <th></th>
                      <th>Grau de Parentesco</th>
                      <th>Nome</th>
                      <th>Data de Nascimento</th>
                      <th>Sexo</th>
                      <th>CPF</th>
                    </tr>
                  </thead>
                  <tbody>
                    {ListaDependentes.map((dep: DependenteEntidade, index: number) => {
                      const Removido = dep.IND_OPERACAO === "EXC";
                      const cor = Removido ? " text-danger" : index % 2 === 0 ? " table-active" : "";
                      return (
                        <tr className={cor} key={index}>
                          <td>
                            <IconContainer className={`btn btn-${Removido ? "danger" : "success"}`}>
                              <Icon title={title[dep.IND_OPERACAO]}>
                                {icons[dep.IND_OPERACAO]}
                              </Icon>
                            </IconContainer>
                          </td>
                          <td>
                            {dep.DS_GRAU_PARENTESCO}
                          </td>
                          <td>
                            {dep.NOME_DEP}
                          </td>
                          <td>
                            {dep.DT_NASC_DEP ? moment(dep.DT_NASC_DEP, "DD/MM/YYYY").format("DD/MM/YYYY") : ""}
                          </td>
                          <td>
                            {dep.SEXO_DEP === "F" ? "FEMININO" : "MASCULINO"}
                          </td>
                          <td>
                            {dep.CPF}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </Box>
            }

            {ListaDependentes.length === 0 && <Alert type={"warning"}>{"Sem alteração nos Beneficiários para fins de Pensão/Benefício por Morte."}</Alert>}
          </>)}

        {!TeveAlteracoes && <Alert type={"info"}>{"Nenhuma informação foi alterada nos passos anteriores. Contudo, você deve concluir seu recadastramento abaixo."}</Alert>}
      </>}
    </>
  );
}